import { gql } from 'apollo-boost';
export const getWebsiteDataVersion = gql`
  query getWebsiteDataForBiz($bizId: ID!) {
    getWebsiteDataForBiz(input: { bizId: $bizId }) {
      version
    }
  }
`;
